import { render, staticRenderFns } from "./ContactEditor.vue?vue&type=template&id=0683fc10&"
import script from "./ContactEditor.vue?vue&type=script&lang=js&"
export * from "./ContactEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports